import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import { useTranslations } from 'next-intl';

interface IProps {
  description?: string;
}

const Info: React.FC<IProps> = ({ description }) => {
  const t = useTranslations();

  return (
    <div className="rounded-lg bg-white px-3 py-2">
      <div className="text-md space-x-3 font-medium">
        <InfoCircleFilled className="text-md rotate-180" />
        <span>{t('men_haqimda')}</span>
      </div>
      <p className="mt-1 whitespace-pre-line text-sm">{description}</p>
    </div>
  );
};

export default Info;
